import { MailCheck, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const FormSubmitted = () => {  

  return (
    <div className="flex min-h-[calc(100vh-4rem)] w-full flex-col items-center justify-center bg-black px-4 relative overflow-hidden">
      {/* Subtle background accent */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-harvey-red/5 blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center space-y-6 sm:space-y-8 max-w-lg">
        {/* Icon */}
        <div className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-harvey-red/10 border border-harvey-red/20">
          <MailCheck className="w-10 h-10 sm:w-12 sm:h-12 text-harvey-red" />
        </div>

        {/* Heading */}
        <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-white">
          Thank You!
        </h3>

        {/* Divider */}
        <div className="w-16 h-1 rounded-full bg-harvey-red" />

        {/* Message */}
        <p className="text-center text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed px-4">
          We've received your submission, and we're on it.
          <br />
          Our team will get back to you shortly.
        </p>

        {/* Back to home link */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-4 bg-harvey-red hover:bg-harvey-red/90 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default FormSubmitted;